import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBreadcrumbs, LazyContainer, LazyDivider, LazyDrawerProvider, LazyEmptyMessage, LazyMinimalContainer, LazyNotify, LazyNotifyAddToCart, LazyNotifyProgress, LazyNotifyProvider, LazyTypography, LazyDatePicker, LazyFormField, LazyInputAutocomplete, LazyOrderList, LazyAssortmentFilter, LazyAssortmentFilterAndSort, LazyListingProductCard, LazyEmailForm, LazyLoginForm, LazyRegistrationForm, LazyFormValues, LazyCartItemListSection, LazyCouponSection, LazyErrorMessageSection, LazyShoppingCartSidebar, LazySummarySection, LazyUspSection, LazyChangeCartSolution, LazyChangeShipmentMethodSolution, LazyDeliveryMethodSolution, LazyAddress, LazyAddressForm, LazyChangeAddressSidebar, LazyDaySelector, LazyDeliveryCheckoutOption, LazyDeliveryTimeslotSelector, LazyFamilyUspSection, LazyPickupCheckoutOption, LazyPickupTimeslotSelector, LazyShoppingCartOverview, LazyOverviewDeliveryInfo, LazyOverviewItem, LazyOverviewPaymentMethod, LazyOverviewPersonalDetails, LazyOverviewPickInfo, LazyOverviewTimeslot, LazyPaymentMethodCash, LazyPaymentMethodCreditcard, LazyPaymentMethodIdeal, LazyCreateReviewForm, LazyCrossSellSection, LazyProductConfigurator, LazyProductDetailPage, LazyProductPrice, LazyProductReviewCounter, LazyProductReviews, LazyProductSpecifications, LazyProductStockNotification, LazyProductUsp, LazyOrderDetailSidebar, LazyPersonalDetailsFormSidebar, LazyShippingMethodSidebar, LazyCreateProductsReviewsForm, LazyLocationResult, LazyMergeCarts, LazyPickupLocationContactPrompt, LazyPickupLocationPrompt, LazySnowflakes, LazyStoreLocationSearch, LazyMap, LazyMarker, LazyAddToCartButton, LazyCategoriesCarousel, LazyContinueShoppingPrompt, LazyCrossSellPrompt, LazyDepositProductPrompt, LazyFullScreenSearch, LazyShippingMethodButton, LazyUspBarAccountButton, LazyUspBarSearchButton, LazyKippieAccordion, LazyKippieAlert, LazyKippieAutoComplete, LazyKippieButton, LazyKippieCard, LazyKippieCarouselButton, LazyKippieCheckbox, LazyKippieCheckoutProgressbarIcon, LazyKippieDaySelector, LazyKippieDropdown, LazyKippieFaq, LazyKippieIconButton, LazyKippieInput, LazyKippieLabel, LazyKippieLink, LazyKippieLoader, LazyKippieMap, LazyKippieOpeningHours, LazyKippieProgressBar, LazyKippieQuantitySelector, LazyKippieQuoteCard, LazyKippieRadioGroup, LazyKippieRatingInput, LazyKippieReviewStars, LazyKippieSearch, LazyKippieSnackbar, LazyKippieText, LazyKippieTiktokPost, LazyKippieTimelineIcon, LazyKippieToggle, LazyKippieTooltip, LazyKippieUspBar, LazyKippieUspList, LazyKippieVideo, LazyAccount, LazyArrowBack, LazyCard, LazyCash, LazyCheckRound, LazyCheck, LazyChevronDown, LazyChevronLeft, LazyChevronRight, LazyChevronUp, LazyChicken, LazyCircleIcon, LazyClock, LazyClose, LazyDelivery, LazyDouble, LazyEdit, LazyEgg, LazyEnvelope, LazyFacebook, LazyFilterIcon, LazyHamburger, LazyHeartFilled, LazyHeart, LazyIdeal, LazyIcons, LazyInfo, LazyInstagram, LazyKippie, LazyLeaf, LazyLocationPin, LazyLocation, LazyMinus, LazyMoon, LazyPageInfo, LazyPaypal, LazyPercent, LazyPhone, LazyPlaceholder, LazyPlus, LazyPuzzle, LazySearch, LazyShoppingBag, LazySingle, LazyStar, LazyStore, LazySun, LazySunrise, LazyTiktok, LazyTrash, LazyVisa, LazyComponents, LazyKippieBlogCard, LazyKippieCartItem, LazyKippieCheckoutProgressbar, LazyKippieContentBanner, LazyKippieCrossSellProduct, LazyKippieCrossSellProductSelector, LazyKippieDrawer, LazyKippieFiltering, LazyKippieMainBanner, LazyKippieNewsLetter, LazyKippiePopup, LazyKippieProductCard, LazyKippieProductTeaserCard, LazyKippiePromotionBanner, LazyKippieReviewCharts, LazyKippieReviewComment, LazyKippieSearchResultCard, LazyKippieSidebar, LazyKippieTimeSlotSelector, LazyKippieVacancyCard, LazyKippieCarousel, LazyKippieFooter, LazyKippieFullScreenSearch, LazyKippieNavbar, LazyKippieOrderDropdown, LazyRouteLink, LazySvgIcon, LazyBirdForm, LazyBirthdayCta, LazyBlog, LazyBlogHighlight, LazyBlogOverview, LazyButtonBar, LazyCarousel, LazyChooseKippie, LazyContentBanner, LazyContentCenter, LazyContentForm, LazyContentGrid, LazyContentText, LazyContentTitle, LazyCookieDeclaration, LazyCustomerServiceButtons, LazyCustomerServiceSection, LazyFaq, LazyFaqSection, LazyFaqTitleLeft, LazyGeneralConditions, LazyHero, LazyImageContent, LazyLinkButton, LazyOpeningHours, LazyPage, LazyPageHeader, LazyPopup, LazyPreparation, LazyPreparationOverview, LazyPreparationSearcher, LazyPromotionBanner, LazyPromotionBannerSection, LazyQuoteCarousel, LazyStoreLocator, LazyStoryblokBreadcrumbs, LazyTextHeader, LazyTypeForm, LazyVacancy, LazyVacancyCarousel, LazyVideoSection, LazyCtaSection, LazyPreparationWrapper, LazyScriptCarbonAds, LazyScriptCrisp, LazyScriptGoogleAdsense, LazyScriptGoogleMaps, LazyScriptIntercom, LazyScriptLemonSqueezy, LazyScriptLoadingIndicator, LazyScriptStripePricingTable, LazyScriptVimeoPlayer, LazyScriptYouTubePlayer } from '#components'
const lazyGlobalComponents = [
  ["Breadcrumbs", LazyBreadcrumbs],
["Container", LazyContainer],
["Divider", LazyDivider],
["DrawerProvider", LazyDrawerProvider],
["EmptyMessage", LazyEmptyMessage],
["MinimalContainer", LazyMinimalContainer],
["Notify", LazyNotify],
["NotifyAddToCart", LazyNotifyAddToCart],
["NotifyProgress", LazyNotifyProgress],
["NotifyProvider", LazyNotifyProvider],
["Typography", LazyTypography],
["DatePicker", LazyDatePicker],
["FormField", LazyFormField],
["InputAutocomplete", LazyInputAutocomplete],
["OrderList", LazyOrderList],
["AssortmentFilter", LazyAssortmentFilter],
["AssortmentFilterAndSort", LazyAssortmentFilterAndSort],
["ListingProductCard", LazyListingProductCard],
["EmailForm", LazyEmailForm],
["LoginForm", LazyLoginForm],
["RegistrationForm", LazyRegistrationForm],
["FormValues", LazyFormValues],
["CartItemListSection", LazyCartItemListSection],
["CouponSection", LazyCouponSection],
["ErrorMessageSection", LazyErrorMessageSection],
["ShoppingCartSidebar", LazyShoppingCartSidebar],
["SummarySection", LazySummarySection],
["UspSection", LazyUspSection],
["ChangeCartSolution", LazyChangeCartSolution],
["ChangeShipmentMethodSolution", LazyChangeShipmentMethodSolution],
["DeliveryMethodSolution", LazyDeliveryMethodSolution],
["Address", LazyAddress],
["AddressForm", LazyAddressForm],
["ChangeAddressSidebar", LazyChangeAddressSidebar],
["DaySelector", LazyDaySelector],
["DeliveryCheckoutOption", LazyDeliveryCheckoutOption],
["DeliveryTimeslotSelector", LazyDeliveryTimeslotSelector],
["FamilyUspSection", LazyFamilyUspSection],
["PickupCheckoutOption", LazyPickupCheckoutOption],
["PickupTimeslotSelector", LazyPickupTimeslotSelector],
["ShoppingCartOverview", LazyShoppingCartOverview],
["OverviewDeliveryInfo", LazyOverviewDeliveryInfo],
["OverviewItem", LazyOverviewItem],
["OverviewPaymentMethod", LazyOverviewPaymentMethod],
["OverviewPersonalDetails", LazyOverviewPersonalDetails],
["OverviewPickInfo", LazyOverviewPickInfo],
["OverviewTimeslot", LazyOverviewTimeslot],
["PaymentMethodCash", LazyPaymentMethodCash],
["PaymentMethodCreditcard", LazyPaymentMethodCreditcard],
["PaymentMethodIdeal", LazyPaymentMethodIdeal],
["CreateReviewForm", LazyCreateReviewForm],
["CrossSellSection", LazyCrossSellSection],
["ProductConfigurator", LazyProductConfigurator],
["ProductDetailPage", LazyProductDetailPage],
["ProductPrice", LazyProductPrice],
["ProductReviewCounter", LazyProductReviewCounter],
["ProductReviews", LazyProductReviews],
["ProductSpecifications", LazyProductSpecifications],
["ProductStockNotification", LazyProductStockNotification],
["ProductUsp", LazyProductUsp],
["OrderDetailSidebar", LazyOrderDetailSidebar],
["PersonalDetailsFormSidebar", LazyPersonalDetailsFormSidebar],
["ShippingMethodSidebar", LazyShippingMethodSidebar],
["CreateProductsReviewsForm", LazyCreateProductsReviewsForm],
["LocationResult", LazyLocationResult],
["MergeCarts", LazyMergeCarts],
["PickupLocationContactPrompt", LazyPickupLocationContactPrompt],
["PickupLocationPrompt", LazyPickupLocationPrompt],
["Snowflakes", LazySnowflakes],
["StoreLocationSearch", LazyStoreLocationSearch],
["Map", LazyMap],
["Marker", LazyMarker],
["AddToCartButton", LazyAddToCartButton],
["CategoriesCarousel", LazyCategoriesCarousel],
["ContinueShoppingPrompt", LazyContinueShoppingPrompt],
["CrossSellPrompt", LazyCrossSellPrompt],
["DepositProductPrompt", LazyDepositProductPrompt],
["FullScreenSearch", LazyFullScreenSearch],
["ShippingMethodButton", LazyShippingMethodButton],
["UspBarAccountButton", LazyUspBarAccountButton],
["UspBarSearchButton", LazyUspBarSearchButton],
["KippieAccordion", LazyKippieAccordion],
["KippieAlert", LazyKippieAlert],
["KippieAutoComplete", LazyKippieAutoComplete],
["KippieButton", LazyKippieButton],
["KippieCard", LazyKippieCard],
["KippieCarouselButton", LazyKippieCarouselButton],
["KippieCheckbox", LazyKippieCheckbox],
["KippieCheckoutProgressbarIcon", LazyKippieCheckoutProgressbarIcon],
["KippieDaySelector", LazyKippieDaySelector],
["KippieDropdown", LazyKippieDropdown],
["KippieFaq", LazyKippieFaq],
["KippieIconButton", LazyKippieIconButton],
["KippieInput", LazyKippieInput],
["KippieLabel", LazyKippieLabel],
["KippieLink", LazyKippieLink],
["KippieLoader", LazyKippieLoader],
["KippieMap", LazyKippieMap],
["KippieOpeningHours", LazyKippieOpeningHours],
["KippieProgressBar", LazyKippieProgressBar],
["KippieQuantitySelector", LazyKippieQuantitySelector],
["KippieQuoteCard", LazyKippieQuoteCard],
["KippieRadioGroup", LazyKippieRadioGroup],
["KippieRatingInput", LazyKippieRatingInput],
["KippieReviewStars", LazyKippieReviewStars],
["KippieSearch", LazyKippieSearch],
["KippieSnackbar", LazyKippieSnackbar],
["KippieText", LazyKippieText],
["KippieTiktokPost", LazyKippieTiktokPost],
["KippieTimelineIcon", LazyKippieTimelineIcon],
["KippieToggle", LazyKippieToggle],
["KippieTooltip", LazyKippieTooltip],
["KippieUspBar", LazyKippieUspBar],
["KippieUspList", LazyKippieUspList],
["KippieVideo", LazyKippieVideo],
["Account", LazyAccount],
["ArrowBack", LazyArrowBack],
["Card", LazyCard],
["Cash", LazyCash],
["CheckRound", LazyCheckRound],
["Check", LazyCheck],
["ChevronDown", LazyChevronDown],
["ChevronLeft", LazyChevronLeft],
["ChevronRight", LazyChevronRight],
["ChevronUp", LazyChevronUp],
["Chicken", LazyChicken],
["CircleIcon", LazyCircleIcon],
["Clock", LazyClock],
["Close", LazyClose],
["Delivery", LazyDelivery],
["Double", LazyDouble],
["Edit", LazyEdit],
["Egg", LazyEgg],
["Envelope", LazyEnvelope],
["Facebook", LazyFacebook],
["FilterIcon", LazyFilterIcon],
["Hamburger", LazyHamburger],
["HeartFilled", LazyHeartFilled],
["Heart", LazyHeart],
["Ideal", LazyIdeal],
["Icons", LazyIcons],
["Info", LazyInfo],
["Instagram", LazyInstagram],
["Kippie", LazyKippie],
["Leaf", LazyLeaf],
["LocationPin", LazyLocationPin],
["Location", LazyLocation],
["Minus", LazyMinus],
["Moon", LazyMoon],
["PageInfo", LazyPageInfo],
["Paypal", LazyPaypal],
["Percent", LazyPercent],
["Phone", LazyPhone],
["Placeholder", LazyPlaceholder],
["Plus", LazyPlus],
["Puzzle", LazyPuzzle],
["Search", LazySearch],
["ShoppingBag", LazyShoppingBag],
["Single", LazySingle],
["Star", LazyStar],
["Store", LazyStore],
["Sun", LazySun],
["Sunrise", LazySunrise],
["Tiktok", LazyTiktok],
["Trash", LazyTrash],
["Visa", LazyVisa],
["Components", LazyComponents],
["KippieBlogCard", LazyKippieBlogCard],
["KippieCartItem", LazyKippieCartItem],
["KippieCheckoutProgressbar", LazyKippieCheckoutProgressbar],
["KippieContentBanner", LazyKippieContentBanner],
["KippieCrossSellProduct", LazyKippieCrossSellProduct],
["KippieCrossSellProductSelector", LazyKippieCrossSellProductSelector],
["KippieDrawer", LazyKippieDrawer],
["KippieFiltering", LazyKippieFiltering],
["KippieMainBanner", LazyKippieMainBanner],
["KippieNewsLetter", LazyKippieNewsLetter],
["KippiePopup", LazyKippiePopup],
["KippieProductCard", LazyKippieProductCard],
["KippieProductTeaserCard", LazyKippieProductTeaserCard],
["KippiePromotionBanner", LazyKippiePromotionBanner],
["KippieReviewCharts", LazyKippieReviewCharts],
["KippieReviewComment", LazyKippieReviewComment],
["KippieSearchResultCard", LazyKippieSearchResultCard],
["KippieSidebar", LazyKippieSidebar],
["KippieTimeSlotSelector", LazyKippieTimeSlotSelector],
["KippieVacancyCard", LazyKippieVacancyCard],
["KippieCarousel", LazyKippieCarousel],
["KippieFooter", LazyKippieFooter],
["KippieFullScreenSearch", LazyKippieFullScreenSearch],
["KippieNavbar", LazyKippieNavbar],
["KippieOrderDropdown", LazyKippieOrderDropdown],
["RouteLink", LazyRouteLink],
["SvgIcon", LazySvgIcon],
["BirdForm", LazyBirdForm],
["BirthdayCta", LazyBirthdayCta],
["Blog", LazyBlog],
["BlogHighlight", LazyBlogHighlight],
["BlogOverview", LazyBlogOverview],
["ButtonBar", LazyButtonBar],
["Carousel", LazyCarousel],
["ChooseKippie", LazyChooseKippie],
["ContentBanner", LazyContentBanner],
["ContentCenter", LazyContentCenter],
["ContentForm", LazyContentForm],
["ContentGrid", LazyContentGrid],
["ContentText", LazyContentText],
["ContentTitle", LazyContentTitle],
["CookieDeclaration", LazyCookieDeclaration],
["CustomerServiceButtons", LazyCustomerServiceButtons],
["CustomerServiceSection", LazyCustomerServiceSection],
["Faq", LazyFaq],
["FaqSection", LazyFaqSection],
["FaqTitleLeft", LazyFaqTitleLeft],
["GeneralConditions", LazyGeneralConditions],
["Hero", LazyHero],
["ImageContent", LazyImageContent],
["LinkButton", LazyLinkButton],
["OpeningHours", LazyOpeningHours],
["Page", LazyPage],
["PageHeader", LazyPageHeader],
["Popup", LazyPopup],
["Preparation", LazyPreparation],
["PreparationOverview", LazyPreparationOverview],
["PreparationSearcher", LazyPreparationSearcher],
["PromotionBanner", LazyPromotionBanner],
["PromotionBannerSection", LazyPromotionBannerSection],
["QuoteCarousel", LazyQuoteCarousel],
["StoreLocator", LazyStoreLocator],
["StoryblokBreadcrumbs", LazyStoryblokBreadcrumbs],
["TextHeader", LazyTextHeader],
["TypeForm", LazyTypeForm],
["Vacancy", LazyVacancy],
["VacancyCarousel", LazyVacancyCarousel],
["VideoSection", LazyVideoSection],
["CtaSection", LazyCtaSection],
["PreparationWrapper", LazyPreparationWrapper],
["ScriptCarbonAds", LazyScriptCarbonAds],
["ScriptCrisp", LazyScriptCrisp],
["ScriptGoogleAdsense", LazyScriptGoogleAdsense],
["ScriptGoogleMaps", LazyScriptGoogleMaps],
["ScriptIntercom", LazyScriptIntercom],
["ScriptLemonSqueezy", LazyScriptLemonSqueezy],
["ScriptLoadingIndicator", LazyScriptLoadingIndicator],
["ScriptStripePricingTable", LazyScriptStripePricingTable],
["ScriptVimeoPlayer", LazyScriptVimeoPlayer],
["ScriptYouTubePlayer", LazyScriptYouTubePlayer],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
